// extracted by mini-css-extract-plugin
module.exports = {"card":"styles_card__BVICi","button":"styles_button__HYtSw"};